module.exports = __webpack_public_path__ + "media/TOSOLA_app.0eda8ed7.webm";